import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { dollarUS } from "../../utilities/formatters";
import dayjs from "dayjs";
import { Typography } from "@mui/material";

const ProfitChart = ({ ProfitData }) => {
  const [series, setSeries] = useState([
    {
      name: "Balance",
      type: "line",
      data: [],
    },
  ]);

  const [options, setOptions] = useState({
    colors: ["#0D56EB"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: { show: false },
      height: 350,
      type: "line",
      zoom: { enabled: true },
    },
    dataLabels: { enabled: false },
    stroke: { width: [4], curve: "smooth" },
    grid: { borderColor: "#415672" },
    xaxis: {
      categories: [],
      labels: {
        formatter: (value) => dayjs(value).format("DD/MM/YY HH:mm"), // Format labels with day.js
        style: { colors: "#8B8E93", fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => dollarUS(value), // Assuming this formats to currency
        style: { colors: "#8B8E93", fontSize: "12px" },
      },
    },
    tooltip: {
      show: true,
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
      // custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      //   const date = dayjs(w.config.options.xaxis.categories[dataPointIndex]);
      //   return (
      //     '<div class="arrow_box">' +
      //     '<div class="Annotation-box Red">' +
      //     "<div> Profit: </div>" +
      //     "<span>" +
      //     series[seriesIndex][dataPointIndex] +
      //     "</span>" +
      //     "</div>" +
      //     '<div class="Annotation-box Date">' +
      //     "<span>" +
      //     date.format("DD/MM/YY HH:mm") +
      //     "</span>" +
      //     "</div>" +
      //     "</div>"
      //   );
      // },
    },
  });

  useEffect(() => {
    if (ProfitData) {
      const profit = Object.values(ProfitData.profit);
      const dates = ProfitData.date.map((date_str) =>
        dayjs(date_str).format("DD/MM/YY HH:MM")
      );

      setSeries([{ name: "Balance", type: "line", data: profit }]);
      setOptions((prev) => ({
        ...prev,
        xaxis: { categories: dates },
      }));
    }
  }, [ProfitData]);

  const hasData =
    ProfitData &&
    ProfitData.profit &&
    Object.keys(ProfitData.profit).length > 0;

  return (
    <div id="chart">
      {hasData ? (
        <ReactApexChart options={options} series={series} height={290} />
      ) : (
        <div className="no-data" style={{ marginTop: "60px" }}>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default ProfitChart;
